import { render, staticRenderFns } from "./rsvMsgSmsModi.vue?vue&type=template&id=1354fea5"
import script from "./rsvMsgSmsModi.vue?vue&type=script&lang=js"
export * from "./rsvMsgSmsModi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports